import { Offer } from './Offer';
import { OfferType } from './OfferType';

export interface UpsellContentOffer {
  discount: string;
  isPrimary?: boolean;
  description?: string;
  oldPriceDescription: string;
  order: number;
  title: string;
  image: string;
  oldPrice: number;
  type: OfferType.UPSELL;
}

export interface UpsellOffer extends UpsellContentOffer, Offer {
  oldPriceWithCurrency: string;
}

export const sortUpsellsOffers = (offers: Array<UpsellOffer>) => {
  if (!offers) {
    return [];
  }

  return [...offers].sort((offer1, offer2) => offer1.order - offer2.order);
};
